function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { isEmpty, noop } from "lodash-es";
import { Add, Remove } from "../../icons";
import { useIcon } from "../../helpers";
import { useId, useEventListener } from "../../helpers/hooks";
import { Label } from "../../components/label/Label";
function hasXDecimals(value, decimalPlaces) {
  var decimalValue = value.split(".");
  if (decimalValue.length > 2) return false;
  if (typeof decimalPlaces !== "number") return true;
  if (decimalPlaces === 0 && decimalValue.length === 1) return true;
  if (decimalValue.length === 2 && decimalValue[1].length > decimalPlaces) {
    return false;
  }
  return true;
}
var Input = /*#__PURE__*/React.forwardRef(function Input(_ref, _ref2) {
  var _ref$prefixClassName = _ref.prefixClassName,
    prefixClassName = _ref$prefixClassName === void 0 ? "tui-input" : _ref$prefixClassName,
    name = _ref.name,
    value = _ref.value,
    label = _ref.label,
    tip = _ref.tip,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    placeholder = _ref.placeholder,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$readOnly = _ref.readOnly,
    readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
    _ref$fluid = _ref.fluid,
    fluid = _ref$fluid === void 0 ? false : _ref$fluid,
    _ref$onFocus = _ref.onFocus,
    _onFocus = _ref$onFocus === void 0 ? function () {} : _ref$onFocus,
    _ref$onBlur = _ref.onBlur,
    onBlur = _ref$onBlur === void 0 ? function () {} : _ref$onBlur,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    error = _ref.error,
    type = _ref.type,
    _ref$inputProps = _ref.inputProps,
    inputProps = _ref$inputProps === void 0 ? {} : _ref$inputProps,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    maxWidth = _ref.maxWidth,
    id = _ref.id,
    _ref$unit = _ref.unit,
    unit = _ref$unit === void 0 ? {
      label: "",
      position: "right"
    } : _ref$unit,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? {
      render: undefined,
      position: "right"
    } : _ref$icon,
    _ref$button = _ref.button,
    button = _ref$button === void 0 ? {
      render: undefined,
      position: "right"
    } : _ref$button,
    _ref$numberControl = _ref.numberControl,
    numberControl = _ref$numberControl === void 0 ? false : _ref$numberControl,
    _ref$onNumberControlE = _ref.onNumberControlError,
    onNumberControlError = _ref$onNumberControlE === void 0 ? noop : _ref$onNumberControlE,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? noop : _ref$onClick,
    _ref$tooltip = _ref.tooltip,
    tooltip = _ref$tooltip === void 0 ? "" : _ref$tooltip,
    decimalPlaces = _ref.decimalPlaces;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasFocus = _useState2[0],
    setHasFocus = _useState2[1];
  var inputRef = useRef(null);
  var generatedId = "tui-input-".concat(useId());
  var innerId = id || generatedId;
  var divRef = useRef(null);
  useEventListener(divRef.current, "focusout", function (event) {
    var focusedOnChild = function focusedOnChild() {
      return divRef.current.contains(event.relatedTarget);
    };
    if (disabled || readOnly || focusedOnChild()) return;
    setHasFocus(false);
    onBlur(event);
  }, [onBlur, disabled, readOnly]);
  var handleWheel = function handleWheel(event) {
    if (type === "number" || numberControl) {
      event.target.blur();
    }
  };
  var renderedIcon = useIcon(icon.render);
  function renderIcon() {
    return renderedIcon;
  }
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    React.createElement("div", {
      className: classnames("".concat(prefixClassName, " ").concat(className), {
        "has-error": error
      }),
      tabIndex: -1,
      style: _objectSpread(_objectSpread({}, style), {}, {
        maxWidth: maxWidth
      }),
      ref: divRef,
      onFocus: function onFocus(e) {
        if (disabled || readOnly) return;
        if (!hasFocus) {
          setHasFocus(true);
          _onFocus(e);
        }
      },
      onClick: onClick
    }, label && /*#__PURE__*/React.createElement(Label, _extends({
      className: classnames({
        "read-only": readOnly
      }),
      htmlFor: innerId,
      required: required
    }, tooltip && {
      tooltip: tooltip
    }), label), /*#__PURE__*/React.createElement("div", {
      className: classnames("".concat(prefixClassName, "-wrapper"), {
        "has-error": error,
        focus: hasFocus,
        disabled: disabled,
        "read-only": readOnly
      })
    }, button.render !== undefined && button.position === "left" ? button.render() : null, unit.label && unit.position === "left" ? /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixClassName, "-unit")
    }, unit.label) : null, numberControl ? /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "".concat(prefixClassName, "-number-control"),
      onClick: function onClick() {
        if (!disabled && !readOnly) {
          var newValue = parseFloat(inputRef.current.value || 0) - 1;
          if (inputProps.min === undefined || newValue >= Number(inputProps.min)) {
            inputRef.current.value = newValue;
            onChange({
              target: {
                name: name,
                value: newValue
              }
            });
          } else {
            onNumberControlError("-");
          }
        }
      }
    }, /*#__PURE__*/React.createElement(Remove, null)) : null, /*#__PURE__*/React.createElement("div", {
      className: classnames("".concat(prefixClassName, "-icon-wrapper"), {
        fluid: fluid,
        unit: unit.label,
        button: button.render !== undefined,
        icon: icon.render !== undefined,
        right: icon.render !== undefined && icon.position !== "left" || unit.label && unit.position !== "left" || button.render !== undefined && button.position !== "left",
        left: icon.render !== undefined && icon.position === "left" || unit.label && unit.position === "left" || button.render !== undefined && button.position === "left"
      })
    }, icon.render !== undefined && icon.position === "left" ? renderIcon() : null, /*#__PURE__*/React.createElement("input", _extends({
      ref: function ref(elRef) {
        inputRef.current = elRef;
        if (typeof _ref2 === "function") {
          _ref2(elRef);
        } else if (_ref2) {
          // eslint-disable-next-line no-param-reassign
          _ref2.current = elRef;
        }
      },
      className: classnames(className, _defineProperty({
        "has-error": error
      }, "".concat(prefixClassName, "-number-control"), numberControl)),
      onWheel: handleWheel,
      onChange: onChange,
      name: name,
      placeholder: placeholder,
      disabled: disabled || readOnly,
      type: type,
      id: innerId
    }, inputProps, {
      value: value,
      onPaste: function onPaste(e) {
        if (type !== "number") return;
        var value = e.clipboardData.getData("Text");
        if (!/^[0-9.]*$/.test(value) || !hasXDecimals(value, decimalPlaces)) {
          e.preventDefault();
        }
      },
      onKeyDown: function onKeyDown(e) {
        if (type === "number") {
          var pressedNumKey = /^[0-9.-]*$/.test(e.key);
          if (!(pressedNumKey || e.keyCode >= 3 && e.keyCode <= 47) && !e.ctrlKey && !e.altKey) {
            e.preventDefault();
            e.stopPropagation();
          } else if (pressedNumKey && decimalPlaces !== undefined) {
            if (decimalPlaces === 0 && e.key === "." || !hasXDecimals(e.currentTarget.value + e.key, decimalPlaces) || e.target.value !== "" && e.key === "-") {
              e.preventDefault();
              e.stopPropagation();
            }
          }
        }
        if (inputProps.onKeyDown !== undefined) {
          inputProps.onKeyDown(e);
        }
      }
    })), icon.render !== undefined && icon.position !== "left" ? renderIcon() : null), numberControl ? /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "".concat(prefixClassName, "-number-control"),
      onClick: function onClick() {
        if (!disabled && !readOnly) {
          var newValue = parseFloat(inputRef.current.value || 0) + 1;
          if (inputProps.max === undefined || newValue <= Number(inputProps.max)) {
            inputRef.current.value = newValue;
            onChange({
              target: {
                name: name,
                value: newValue
              }
            });
          } else {
            onNumberControlError("+");
          }
        }
      }
    }, /*#__PURE__*/React.createElement(Add, null)) : null, unit.label && unit.position !== "left" ? /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixClassName, "-unit")
    }, unit.label) : null, button.render !== undefined && button.position !== "left" ? button.render() : null), tip ? /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixClassName, "-tip")
    }, tip) : null, error && !isEmpty(error) ? /*#__PURE__*/React.createElement("div", {
      className: "tui-invalid-feedback",
      children: error
    }) : "")
  );
});
Input.displayName = "Input";
export var InputPropTypes = {
  prefixClassName: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string,
  tip: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  fluid: PropTypes.bool,
  readOnly: PropTypes.bool,
  style: PropTypes.object,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  id: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.node, PropTypes.bool]),
  numberControl: PropTypes.bool,
  unit: PropTypes.shape({
    position: PropTypes.string,
    label: PropTypes.string
  }),
  icon: PropTypes.shape({
    position: PropTypes.string,
    render: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
  }),
  button: PropTypes.shape({
    position: PropTypes.string,
    render: PropTypes.func
  }),
  inputProps: PropTypes.object,
  onNumberControlError: PropTypes.func,
  onClick: PropTypes.func,
  tooltip: PropTypes.string,
  decimalPlaces: PropTypes.number
};
Input.propTypes = InputPropTypes;
export default Input;
//# sourceMappingURL=Input.js.map